import messages from 'vee-validate/dist/locale/zh_CN';

export default {
    messages: {
        ...messages.messages,
        login() {
            return 'The specified user does not exist.';
        },
        unique() {
            return 'Email already exists';
        },
        enabled() {
            return 'The specified user has been disabled.';
        },
        locked() {
            return 'Your access has been restricted. Please contact your Manager.';
        },
    },
    attributes: {
        name: 'name',
        email: 'email',
        password: 'password',
        confirmPassword: 'confirm password',
    },
};



// WEBPACK FOOTER //
// ./src/lang/zh/validator.js